<template>
  <div class="d-flex flex-column" style="row-gap: 4px">
    <div class="d-flex flex-column px-4 py-2 rounded justify-center"
      style="background-color: white; max-width: 360px; line-height: 1.4; font-size: 16px; border: 1px solid #BDBDBD"
    >
      <div>
        Stay logged in, complete daily actions, and watch your badge collection grow.
      </div>
    </div>

    <Badge 
      v-for="badge in badges" 
      :key="badge.achievement_id"
      :badge="badge"
    />
  </div>
</template>

<script>
  import Badge from './Badge'

  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'BadgesCard',

    components: { Badge },

    computed: {
      ...mapGetters('auth', ['badges']),
    },

    methods: {
      ...mapActions('auth', ['loadBadges']),
    },

    async created() {
      this.loadBadges()
    },
  }
</script>